export default __webpack_public_path__ + "static/media/i247jp.4822e1a0.webp";